(function () {
  'use strict';

  // ---------- Helpers ----------
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  function pulseCartIcon() {
    var btn = document.getElementById('cartBtn');
    if (!btn || !btn.animate) return;
    btn.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }],
      { duration: 260, easing: 'ease-out' }
    );
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  // ---------- Mobile nav ----------
  function initMobileNav() {
    var toggle = document.getElementById('menuToggle');
    var nav = document.getElementById('mainNav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
      toggle.classList.toggle('active');
    });
  }

  // ---------- Header scroll shadow ----------
  function initHeaderScroll() {
    var header = document.getElementById('siteHeader');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 8 ? '0 8px 24px -12px rgba(0,0,0,.5)' : 'none';
    });
  }

  // ---------- Product card quick-add (collection/grid cards) ----------
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.disabled = true;
      addToCart(variantId, 1)
        .then(function () {
          refreshCartCount();
          pulseCartIcon();
        })
        .catch(function () {})
        .finally(function () { btn.disabled = false; });
    });
  }

  // ---------- Accordion (used on product page) ----------
  function initAccordion() {
    document.querySelectorAll('.accordion-head').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.accordion-item');
        var wasOpen = item.classList.contains('open');
        var accordion = item.closest('.accordion');
        accordion.querySelectorAll('.accordion-item').forEach(function (i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  // ---------- Product page: gallery + variant picker + add to cart ----------
  function initProductForms() {
    document.querySelectorAll('[data-product-json]').forEach(function (root) {
      var sectionId = root.getAttribute('data-section-id');
      var jsonEl = document.getElementById('ProductJson-' + sectionId);
      if (!jsonEl) return;

      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var form = root.querySelector('#productForm');
      var variantInput = root.querySelector('#variantIdInput');
      var priceNow = root.querySelector('#priceNow');
      var priceWas = root.querySelector('#priceWas');
      var priceSave = root.querySelector('#priceSave');
      var addPrice = root.querySelector('#addPrice');
      var addLabel = root.querySelector('#addToCartLabel');
      var addBtn = root.querySelector('#addToCartBtn');
      var stockNote = root.querySelector('#stockNote');
      var mainImg = root.querySelector('#galleryMainImg');
      var optionButtons = root.querySelectorAll('.size-pill[data-option-index]');
      var qtyValue = root.querySelector('#qtyValue');
      var qtyInput = root.querySelector('#qtyInput');
      var qtyMinus = root.querySelector('#qtyMinus');
      var qtyPlus = root.querySelector('#qtyPlus');

      // Build current selection from the option group order present on the page
      var optionGroups = [];
      root.querySelectorAll('.option-block[data-option-index]').forEach(function (block) {
        optionGroups.push(block.getAttribute('data-option-index'));
      });

      var selected = {};
      optionGroups.forEach(function (key) {
        var activeBtn = root.querySelector('.size-pill[data-option-index="' + key + '"].active');
        selected[key] = activeBtn ? activeBtn.getAttribute('data-value') : null;
      });

      function findVariant() {
        return variants.find(function (v) {
          var opts = [v.option1, v.option2, v.option3];
          return optionGroups.every(function (key, i) {
            return opts[i] === selected[key];
          });
        });
      }

      function setQty(n) {
        n = Math.max(1, n);
        if (qtyValue) qtyValue.textContent = n;
        if (qtyInput) qtyInput.value = n;
        syncPrice();
      }

      function syncPrice() {
        var variant = findVariant();
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (!variant) return;

        if (priceNow) priceNow.textContent = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (priceWas) { priceWas.textContent = formatMoney(variant.compare_at_price); priceWas.style.display = ''; }
          if (priceSave) {
            var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            priceSave.textContent = 'Save ' + pct + '%';
            priceSave.style.display = '';
          }
        } else {
          if (priceWas) priceWas.style.display = 'none';
          if (priceSave) priceSave.style.display = 'none';
        }

        if (addPrice) addPrice.textContent = formatMoney(variant.price * qty);
        if (variantInput) variantInput.value = variant.id;

        if (variant.featured_image && mainImg && mainImg.tagName === 'IMG') {
          mainImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_1200x$1$2');
        }

        if (variant.available) {
          if (addBtn) addBtn.disabled = false;
          if (addLabel) addLabel.textContent = 'Add to Cart —';
          if (addPrice) addPrice.style.display = '';
          if (stockNote) {
            stockNote.classList.remove('is-unavailable');
            if (variant.inventory_management && variant.inventory_quantity <= 10 && variant.inventory_quantity > 0) {
              stockNote.lastChild.textContent = ' Only ' + variant.inventory_quantity + ' left — ships in 2–4 days';
            } else {
              stockNote.lastChild.textContent = ' In stock — ships in 2–4 days';
            }
          }
        } else {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Sold Out';
          if (addPrice) addPrice.style.display = 'none';
          if (stockNote) stockNote.lastChild.textContent = ' Currently unavailable';
        }

        updateStickyBuy(variant, qty);
      }

      optionButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-option-index');
          selected[key] = btn.getAttribute('data-value');

          root.querySelectorAll('.size-pill[data-option-index="' + key + '"]').forEach(function (b) {
            b.classList.toggle('active', b === btn);
          });
          var labelEl = btn.closest('.option-block').querySelector('.option-current');
          if (labelEl) labelEl.textContent = selected[key];

          syncPrice();
        });
      });

      if (qtyMinus) qtyMinus.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) - 1);
      });
      if (qtyPlus) qtyPlus.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) + 1);
      });

      // Gallery thumbnails
      var thumbs = root.querySelectorAll('.thumb[data-full]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          if (mainImg && mainImg.tagName === 'IMG') mainImg.src = thumb.getAttribute('data-full');
        });
      });

      // Add to cart (AJAX)
      var cartError = root.querySelector('#cartError');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var variant = findVariant();
          if (cartError) cartError.textContent = '';
          if (!variant || !variant.available) {
            if (cartError) cartError.textContent = 'That combination is sold out.';
            return;
          }
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          if (addBtn) addBtn.disabled = true;
          addToCart(variant.id, qty)
            .then(function () {
              refreshCartCount();
              pulseCartIcon();
            })
            .catch(function (err) {
              if (cartError) cartError.textContent = (err && err.message) || 'Could not add to cart. Please try again.';
            })
            .finally(function () { if (addBtn) addBtn.disabled = false; });
        });
      }

      syncPrice();
    });
  }

  // ---------- Sticky mobile buy bar ----------
  function updateStickyBuy(variant, qty) {
    var bar = document.getElementById('stickyBuy');
    if (!bar || !variant) return;
    var priceEl = document.getElementById('stickyPrice');
    var metaEl = document.getElementById('stickyMeta');
    var nameEl = document.getElementById('stickyBuyName');
    var imgEl = document.getElementById('stickyBuyImg');
    if (priceEl) priceEl.textContent = formatMoney(variant.price * (qty || 1));
    if (metaEl) metaEl.textContent = variant.title !== 'Default Title' ? variant.title : '';
    if (nameEl) nameEl.textContent = document.querySelector('.product-title') ? document.querySelector('.product-title').textContent : '';
    if (imgEl && variant.featured_image) imgEl.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2');

    bar.dataset.currentVariantId = variant.id;
    bar.dataset.currentQty = qty || 1;
  }

  function initStickyBuy() {
    var bar = document.getElementById('stickyBuy');
    var trigger = document.querySelector('.buy-row');
    if (!bar || !trigger) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(trigger);

    var stickyAddBtn = document.getElementById('stickyAddBtn');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        var variantId = bar.dataset.currentVariantId;
        var qty = parseInt(bar.dataset.currentQty, 10) || 1;
        if (!variantId) return;
        stickyAddBtn.disabled = true;
        addToCart(variantId, qty)
          .then(function () {
            refreshCartCount();
            pulseCartIcon();
          })
          .catch(function () {})
          .finally(function () { stickyAddBtn.disabled = false; });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initHeaderScroll();
    initQuickAdd();
    initAccordion();
    initProductForms();
    initStickyBuy();
  });
})();
